import React from 'react';
import NodesApp from 'components/nodeInterface/NodesApp';

function NodeInterfacePage() {
  return <NodesApp />;
}

export default NodeInterfacePage;
